module.exports = __webpack_public_path__ + "img/summary_web_banner.b2707c9e.png";